<template>

    <div v-cloak>
        <div id="compose-message-dialog" class="modal pl-0 pr-0" tabindex="-1" role="dialog" data-backdrop="static" aria-label="Compose Message Dialog">
            <div v-bind:class="dialogCssClassToUse" class="modal-dialog" role="document">

                <div class="modal-content">

                    <div v-if="isLoading">
                        <div class="loading-div" v-if="isLoading">{{ isLoadingContent }}</div>
                    </div>

                    <div v-if="!isLoading">
                        <div v-if="mode == 'Entry'">
                            <div v-show="showHeader" class="modal-header pb-1">
                                <div class="container col-12 pl-0 pl-lg-2 pr-0 pr-lg-2">
                                    <div class="row">
                                        <div class="col">
                                        </div>
                                        <div class="col-auto">
                                            <button type="button" class="close text-white btn-circle close-filter-dialog-button close-dialog-icon c-pointer m-0 p-0" data-dismiss="modal" aria-label="Close Popup">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-body pt-1">

                                <template-selector-component v-if="!selectedTemplateData"
                                                             :recently-used-templates="recentlyUsedTemplates"
                                                             :template-reference-data="navigationMenuItems"
                                                             :cms-content-blocks="cmsContentBlocks"
                                                             :non-english="nonEnglish"
                                                             @templateSelected="templateSelected"></template-selector-component>

                                <div v-if="selectedTemplateData">

                                    <appointment-request-component v-if="selectedTemplateData.isAppointmentTemplate"
                                                                   :pre-selected-request-type-id="selectedTemplateData.requestType"
                                                                   :physician-drop-down="physicianDropDownData"
                                                                   :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                                   :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                                   :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                                   :future-appointments-on-file="cachedFutureAppointments"
                                                                   :error-model="errorModel"
                                                                   :cms-content-blocks="cmsContentBlocks"
                                                                   :pre-selected-appointment-id="selectedIdToGoTo"
                                                                   :appt-outage="apptOutage"
                                                                   :non-english="nonEnglish"
                                                                   @showHideHeaderFooter="showHideHeaderFooter"
                                                                   @setMessageObject="setMessageObject"></appointment-request-component>

                                    <care-coordinator-component v-if="selectedTemplateData.id == 'MskDirectCareCoordinator'"
                                                                :error-model="errorModel"
                                                                :cms-content-blocks="cmsContentBlocks"
                                                                :non-english="nonEnglish"
                                                                @setMessageObject="setMessageObject">
                                    </care-coordinator-component>

                                    <general-office-communication-component v-if="selectedTemplateData.isGeneralOfficeCommunication"
                                                                            :physician-drop-down="physicianDropDownData"
                                                                            :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                                            :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                                            :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                                            :attachment-group-id="attachmentGroupIdToUse"
                                                                            :subject-drop-down="cachedGeneralCommunicationSubjectList"
                                                                            :error-model="errorModel"
                                                                            :cms-content-blocks="cmsContentBlocks"
                                                                            :pre-selected-subject-id="selectedIdToGoTo"
                                                                            :non-english="nonEnglish"
                                                                            @setMessageObject="setMessageObject"></general-office-communication-component>

                                    <billing-component v-if="selectedTemplateData.id == 'Billing'"
                                                       :attachment-group-id="attachmentGroupIdToUse"
                                                       :error-model="errorModel"
                                                       :cms-content-blocks="cmsContentBlocks"
                                                       @setMessageObject="setMessageObject"
                                                       :non-english="nonEnglish">
                                    </billing-component>

                                    <patient-rep-component v-if="selectedTemplateData.id == 'PatientRep'"
                                                           :attachment-group-id="attachmentGroupIdToUse"
                                                           :physician-drop-down="physicianDropDownData"
                                                           :error-model="errorModel"
                                                           :cms-content-blocks="cmsContentBlocks"
                                                           :non-english="nonEnglish"
                                                           @setMessageObject="setMessageObject">
                                    </patient-rep-component>

                                    <clinical-genetics-component v-if="selectedTemplateData.id == 'ClinicalGenetics'"
                                                                 :attachment-group-id="attachmentGroupIdToUse"
                                                                 :error-model="errorModel"
                                                                 :cms-content-blocks="cmsContentBlocks"
                                                                 :non-english="nonEnglish"
                                                                 @setMessageObject="setMessageObject">
                                    </clinical-genetics-component>

                                    <help-desk-component v-if="selectedTemplateData.id == 'HelpDesk'"
                                                         :attachment-group-id="attachmentGroupIdToUse"
                                                         :error-model="errorModel"
                                                         :cms-content-blocks="cmsContentBlocks"
                                                         :non-english="nonEnglish"
                                                         @setMessageObject="setMessageObject">
                                    </help-desk-component>

                                    <brooklyn-infusion-center-component v-if="selectedTemplateData.id == 'BrooklynInfusionCenter'"
                                                                        :attachment-group-id="attachmentGroupIdToUse"
                                                                        :error-model="errorModel"
                                                                        :cms-content-blocks="cmsContentBlocks"
                                                                        :non-english="nonEnglish"
                                                                        @setMessageObject="setMessageObject">
                                    </brooklyn-infusion-center-component>

                                    <pre-cert-nutritional-supplement-component v-if="selectedTemplateData.id == 'PreCertNutritionalSupplements' || selectedTemplateData.id == 'EDD_PreCertNutritionalSupplements' || selectedTemplateData.id == 'Ctc_PreCertNutritionalSupplements'"
                                                                               :physician-drop-down="physicianDropDownData"
                                                                               :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                                               :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                                               :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                                               :error-model="errorModel"
                                                                               :cms-content-blocks="cmsContentBlocks"
                                                                               @setMessageObject="setMessageObject">
                                    </pre-cert-nutritional-supplement-component>

                                    <pre-cert-test-component v-if="selectedTemplateData.id == 'PreCertTest' || selectedTemplateData.id == 'EDD_PreCertTest' || selectedTemplateData.id == 'Ctc_PreCertTest'"
                                                             :physician-drop-down="physicianDropDownData"
                                                             :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                             :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                             :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                             :error-model="errorModel"
                                                             :cms-content-blocks="cmsContentBlocks"
                                                             @setMessageObject="setMessageObject">
                                    </pre-cert-test-component>
                                    <test-result-inquiry-component v-if="selectedTemplateData.id == 'TestResultsInquiry' || selectedTemplateData.id == 'EDD_TestResultsInquiry' || selectedTemplateData.id == 'Ctc_TestResultsInquiry'"
                                                                   :physician-drop-down="physicianDropDownData"
                                                                   :attachment-group-id="attachmentGroupIdToUse"
                                                                   :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                                   :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                                   :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                                   :error-model="errorModel"
                                                                   :cms-content-blocks="cmsContentBlocks"
                                                                   @setMessageObject="setMessageObject"
                                                                   :pre-selected-request-type-id="selectedTemplateData.requestType"
                                                                   :non-english="nonEnglish">
                                    </test-result-inquiry-component>

                                    <test-result-inquiry-component v-if="selectedTemplateData.id == 'TestResultsInquiry_Radiologist'"
                                                                   :attachment-group-id="attachmentGroupIdToUse"
                                                                   :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                                   :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                                   :error-model="errorModel"
                                                                   :cms-content-blocks="cmsContentBlocks"
                                                                   :non-english="nonEnglish"
                                                                   @setMessageObject="setMessageObject"
                                                                   :pre-selected-request-type-id="selectedTemplateData.requestType"
                                                                   :pre-selected-default-to-mailbox-id="defaultToMailboxid">
                                    </test-result-inquiry-component>

                                    <prescription-refill v-if="selectedTemplateData.id == 'PrescriptionRefill' || selectedTemplateData.id == 'EDD_PrescriptionRefill' || selectedTemplateData.id == 'Ctc_PrescriptionRefill'"
                                                         :physician-drop-down="physicianDropDownData"
                                                         :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                         :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                         :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                         :error-model="errorModel"
                                                         :cms-content-blocks="cmsContentBlocks"
                                                         :cached-prescription-medication="cachedPrescriptionMedication"
                                                         :cached-preferred-pharmacies="cachedPreferredPharmacies"
                                                         :cached-msk-pharmacies="cachedMskPharmacies"
                                                         :pre-selected-prescription-id="selectedIdToGoTo"
                                                         :non-english="nonEnglish"
                                                         @setCachedPrescription="(data) => cachedPrescriptionMedication = data"
                                                         @setCachePreferredPharmacies="(data) => cachedPreferredPharmacies = data"
                                                         @setCacheMskPharmacies="(data) => cachedMskPharmacies = data"
                                                         @hideSend="hideSend"
                                                         @setMessageObject="setMessageObject"></prescription-refill>

                                    <pre-cert-prescription-medication v-if="selectedTemplateData.id == 'PreCertPrescriptionMed' || selectedTemplateData.id == 'EDD_PreCertPrescriptionMed' || selectedTemplateData.id == 'Ctc_PreCertPrescriptionMed'"
                                                                      :physician-drop-down="physicianDropDownData"
                                                                      :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                                      :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                                      :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                                      :error-model="errorModel"
                                                                      :cms-content-blocks="cmsContentBlocks"
                                                                      @hideSend="hideSend"
                                                                      @setMessageObject="setMessageObject"></pre-cert-prescription-medication>

                                    <kb-send-to-msk-component v-if="selectedTemplateData.id == 'KbSendToMsk'"
                                                              :error-model="errorModel"
                                                              :is-portal-user="isPortalUser"
                                                              :cms-content-blocks="cmsContentBlocks"
                                                              :non-english="nonEnglish"
                                                              @setMessageObject="setMessageObject"></kb-send-to-msk-component>

                                    <patient-in-hospital-component v-if="selectedTemplateData.isPatientInHospital"
                                                                   :physician-drop-down="physicianDropDownData"
                                                                   :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                                   :reassign-physician-drop-down="reassignPhysiciansDropDownData"
                                                                   :show-physician-drop-down="selectedTemplateData.showPhysicianDropDown"
                                                                   :attachment-group-id="attachmentGroupIdToUse"
                                                                   :error-model="errorModel"
                                                                   :cms-content-blocks="cmsContentBlocks"
                                                                   :non-english="nonEnglish"
                                                                   @setMessageObject="setMessageObject">
                                    </patient-in-hospital-component>

                                    <radiology-exams-copy-component v-if="selectedTemplateData.id == 'RadiologyExamsCopy'"
                                                                    :physician-drop-down="physicianDropDownData"
                                                                    :send-to-this-mailbox="selectedTemplateData.sendToThisMailbox"
                                                                    :attachment-group-id="attachmentGroupIdToUse"
                                                                    :error-model="errorModel"
                                                                    :cms-content-blocks="cmsContentBlocks"
                                                                    :non-english="nonEnglish"
                                                                    @setMessageObject="setMessageObject"
                                                                    :pre-selected-default-to-mailbox-id="cmsContentBlocks['radiologyExamsCopy.ToMailBoxId']"
                                                                    :pre-selected-default-to-email-id="cmsContentBlocks['radiologyExamsCopy.ToEmailAddress']">
                                    </radiology-exams-copy-component>

                                </div>

                            </div>

                            <div class="modal-footer pt-2 pb-2 bg-portal-secondary-cream">

                                <div class="container-fluid pl-0 pl-lg-3 pr-0 pr-lg-3">

                                    <div v-if="showFooterWithBaseButtons" class="row align-items-center">

                                        <!-- cancel the dialog -->
                                        <div v-if="onlyShowSelectedTemplate">
                                            <div v-if="selectedTemplateData" class="col text-right">
                                                <a href="#" :disabled="isSendingMessage || isUploadingFile" data-dismiss="modal">{{cmsContentBlocks['mainPageCancelButtonText']}}</a>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-if="!selectedTemplateData" class="col text-right">
                                                <button type="button" :disabled="isSendingMessage || isUploadingFile" @click.prevent="hideSendButton=false" data-dismiss="modal" class="btn btn-primary">{{cmsContentBlocks['mainPageCancelButtonText']}}</button>
                                            </div>
                                            <div v-if="selectedTemplateData && isFromContactUs" class="col">
                                                <a href="#" :disabled="isSendingMessage || isUploadingFile" @click.prevent="hideSendButton=false" data-dismiss="modal">{{cmsContentBlocks['mainPageCancelButtonText']}}</a>
                                            </div>
                                            <div v-if="selectedTemplateData && !isFromContactUs" class="col">
                                                <a href="#" :disabled="isSendingMessage || isUploadingFile" @click.prevent="selectedTemplateData = null;hideSendButton=false">{{cmsContentBlocks['mainPageCancelButtonText']}}</a>
                                            </div>
                                        </div>

                                        <div v-if="selectedTemplateData && hideSendButton===false" class="col text-right">
                                            <button type="button" class="btn btn-primary" :disabled="isSendingMessage || isUploadingFile" @click="sendMessage">
                                                <span v-if="isSendingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                <div v-if="!isSendingMessage" class="d-inline">
                                                    <i class="far fa-paper-plane icon-button-w-text" aria-label="Send the message"></i>
                                                </div>{{cmsContentBlocks['mainPageSendButtonText']}}
                                            </button>
                                        </div>
                                    </div>

                                    <div v-else class="row align-items-center">
                                        <div class="col text-right">
                                            <button type="button" :disabled="isSendingMessage || isUploadingFile" @click="doneButtonClicked" class="btn btn-primary">
                                                {{cmsContentBlocks['mainPageDoneButtonText']}}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div v-if="mode == 'Success'">
                            <compose-message-success :header-text="cmsContentBlocks['mainPageSuccessScreenHeader']"
                                                     :sub-header-text="cmsContentBlocks['mainPageSuccessScreenSubHeader']"
                                                     :sub-header-text-important="cmsContentBlocks['mainPageSuccessScreenSubHeaderImportant']"
                                                     :button-text="cmsContentBlocks['mainPageSuccessScreenOkButton']">
                            </compose-message-success>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

    import Vue from 'vue';
    import './message.compose.index.scss';
    import messageTemplateSelectorComponent from './Components/TemplateSelector/message.template.selector.vue';
    import { IsModelStateError } from '@SharedServices/validation.service';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';
    import EventBus from './message.event.bus';
    import { findTemplateByTemplateId } from './message.service';
    import { ApptHttpSvc } from '@PortalHttpServices/portal.appointment.httpservice';
    import { createAttachmentGroupGuid } from './message.service';
    import composeMessageSuccess from '@PortalVueComponents/Success/success.vue';
    import { ResolveStaticContent } from '@SharedServices/localization.service';

    //templates
    import AppointmentRequestComponent from './Components/Templates/AppointmentRequest/appointment.request.template.vue';
    import HelpDeskComponent from './Components/Templates/HelpDesk/help.desk.template.vue';
    import GeneralOfficeCommunicationComponent from './Components/Templates/GeneralOffice/general.office.communications.template.vue';
    import BillingComponent from './Components/Templates/Billing/billing.template.vue';
    import PatientRepComponent from './Components/Templates/PatientRep/patient.rep.template.vue';
    import BrooklynInfusionCenterComponent from './Components/Templates/BrooklynInfusionCenter/brooklyn.infusion.center.template.vue';
    import ClinicalGeneticsComponent from './Components/Templates/ClinicalGenetics/clinical.genetics.template.vue';
    import PreCertNutritionalSupplements from './Components/Templates/PreCertNutritionalSupplements/pre.cert.nutritional.supplements.template.vue';
    import PreCertTest from './Components/Templates/PreCertTest/pre.cert.test.template.vue';
    import PreCertPrescriptionMedication from './Components/Templates/PreCertPrescriptionMedication/pre.cert.prescription.medication.template.vue';
    import TestResultInquiryComponent from './Components/Templates/TestResultInquiry/test.result.inquiry.template.vue';
    import PrescriptionRefill from './Components/Templates/PrescriptionRefill/prescription.refill.template.vue';
    import CareCoordinator from './Components/Templates/CareCoordinator/care.coordinator.template.vue';

    import KbSendToMsk from './Components/Templates/KbSendToMsk/kb.send.to.msk.template.vue';
    import PatientInHospitalComponent from './Components/Templates/PatientInHospital/patient.in.hospital.template.vue';
    import RadiologyExamsCopyComponent from './Components/Templates/RadiologyExamsCopyRequest/radiology.exams.copy.template.vue';

    export default {
        name: 'composeMessageIndex',
        props: {
            preLoadComposeMessageInitData: { type: Object }, //pre load the compose message init. Used in the dashboard to get the message dialog loaded before calling the other tiles.
            futureAppointmentsPreLoaded: { type: Array }, //pre-load the appointments if you have it
            activePrescriptionPreLoaded: { type: Array } //pre load patients active medications (mainly coming from medication screen)
        },
        components: {
            'template-selector-component': messageTemplateSelectorComponent,
            'compose-message-success': composeMessageSuccess,

            //templates
            'appointment-request-component': AppointmentRequestComponent,
            'general-office-communication-component': GeneralOfficeCommunicationComponent,
            'billing-component': BillingComponent,
            'help-desk-component': HelpDeskComponent,
            'patient-rep-component': PatientRepComponent,
            'brooklyn-infusion-center-component': BrooklynInfusionCenterComponent,
            'clinical-genetics-component': ClinicalGeneticsComponent,
            'pre-cert-nutritional-supplement-component': PreCertNutritionalSupplements,
            'pre-cert-test-component': PreCertTest,
            'pre-cert-prescription-medication': PreCertPrescriptionMedication,
            'prescription-refill': PrescriptionRefill,
            'test-result-inquiry-component': TestResultInquiryComponent,
            'kb-send-to-msk-component': KbSendToMsk,
            'patient-in-hospital-component': PatientInHospitalComponent,
            'care-coordinator-component': CareCoordinator,
            'radiology-exams-copy-component': RadiologyExamsCopyComponent
        },
        data: function () {
            return {

                isLoading: true,
                mode: 'Entry', //Success

                //this is a generic id that we pass in to set an active record. ie: appt index --> compose message reschedule an appt. The property would contain the appt id
                selectedIdToGoTo: null,

                isSendingMessage: false,

                isSendingEmailMessage: false,

                isUploadingFile: false,

                isFromContactUs: false,

                //show hide for the components...
                showHeader: true,
                showFooterWithBaseButtons: true, //if true you get the main screen buttons. Otherwise, you get the "done" for the 2nd level screen items

                //selectedDataObject { department: , template: }
                recentlyUsedTemplates: [],

                //physician drop down (used on most templates so we are going to pull that back at the start)
                physicianDropDownData: [],

                //reassign physician drop down (used on CTS templates (for now) so we are going to pull that back at the start)
                reassignPhysiciansDropDownData: [],

                //some screens will get ajax data. If the user goes back and forth we don't want to keep grabbing the same data.
                //the actual component will emit an event to set it the data here.
                cachedFutureAppointments: this.futureAppointmentsPreLoaded,
                cachedGeneralCommunicationSubjectList: [],
                cachedPrescriptionMedication: this.activePrescriptionPreLoaded,
                cachedPreferredPharmacies: null,
                cachedMskPharmacies: null,

                //holds the nav menu we build up
                navigationMenuItems: [],

                //cms content blocks
                cmsContentBlocks: {},

                //is portal (not kb or ppp)
                isPortalUser: null,

                nonEnglish: false,

                //which template is selected
                selectedTemplateData: null,
                attachmentGroupIdToUse: createAttachmentGroupGuid(),

                composeMesageToSend: null,
                errorModel: {},
                apptOutage: false,
                hideSendButton: false,
                defaultToMailboxid: '!RadiologyEx',
                defaultToEmailid: 'imagemanagement@mskcc.org'
            }
        },
        created: function () {
            this.loadInitDataFromCacheOrDataSource()
                .done(response => {
                    this.navigationMenuItems = response.navigationMenuItems;
                    this.isPortalUser = response.isPatientPortalUser;
                    this.recentlyUsedTemplates = response.recentlyUsedTemplateList;
                    this.physicianDropDownData = response.recentDoctorMailboxList;
                    this.reassignPhysiciansDropDownData = response.reassignDoctorMailboxList;
                    this.cmsContentBlocks = response.portalAppointmentComposeMessageContentBlocks;
                    this.cachedGeneralCommunicationSubjectList = response.generalOfficeCommunicationSubjectList;
                    this.nonEnglish = response.selectedLanguage !== 'en';
                    this.isLoading = false;
                    this.$emit('is-loading', false);
                });
        },
        mounted: function () {

            EventBus.$on('goToTemplate', (templateId, idToGoTo, fromContactUs) => {
                this.selectedTemplateData = findTemplateByTemplateId(templateId, this.navigationMenuItems).template;
                this.selectedIdToGoTo = idToGoTo;
                this.isFromContactUs = fromContactUs;
            });

            EventBus.$on('ClearError', (propertyId) => {
                Vue.delete(this.errorModel, propertyId);
            });

            EventBus.$on('IsUploading', (isUploading) => {
                this.isUploadingFile = isUploading;
            });

            $('#compose-message-dialog').on('hidden.bs.modal', e => {

                //when the dialog is closed always reset the "template selector screen"
                this.selectedTemplateData = null;
                this.mode = 'Entry';
                this.hideSendButton = false;

            }).on('show.bs.modal', e => {

                if (this.onlyShowSelectedTemplate) {
                    this.selectedTemplateData = findTemplateByTemplateId(this.navigationMenuItems[0].id, this.navigationMenuItems).template;
                }
            });
        },
        computed: {

            onlyShowSelectedTemplate: function () {
                return this.navigationMenuItems.length == 1;
            },

            dialogCssClassToUse: function () {
                let baseCssClass = null;

                if (this.mode == 'Entry') {

                    baseCssClass = 'modal-xs-100 modal-sm-100 modal-md-75 modal-lg-75 ';

                    //if we really need to modify the size of the dialog alot - clean this up. For now its only help desk
                    if (this.selectedTemplateData && !this.selectedTemplateData.isOneColumnScreen) {
                        baseCssClass += ' modal-xl-75';
                    }
                    else {
                        baseCssClass += ' modal-xl-50';
                    }
                }

                return baseCssClass;
            },

            isLoadingContent: function () {
                return ResolveStaticContent("Loading");
            }
        },
        watch: {

            activePrescriptionPreLoaded: function (newValue, oldValue) {
                this.cachedPrescriptionMedication = newValue;
            },

            futureAppointmentsPreLoaded: function (newValue, oldValue) {
                this.cachedFutureAppointments = newValue;
            },

            selectedTemplateData: function (newValue, oldValue) {

                if (!newValue) {
                    //when we set it to null (reset of the templates we go and clear out any id's we prepopulated)
                    this.selectedIdToGoTo = null;
                }

                //if it's an appointment template and we don't have the future appointments loaded yet then go get it
                if (newValue && newValue.isAppointmentTemplate && !this.cachedFutureAppointments) {
                    //go load the future appointments
                    ApptHttpSvc.GetFutureAppointments(true)
                        .done(response => {
                            this.apptOutage = false;
                            if (response && response.outage && response.outage === true) {
                                this.cachedFutureAppointments = [];
                                this.apptOutage = true;
                            } else {
                                this.cachedFutureAppointments = response
                            }

                        });
                }

                this.composeMesageToSend = {};
                this.errorModel = {};
                this.attachmentGroupIdToUse = createAttachmentGroupGuid();
            }

        },
        methods: {

            loadInitDataFromCacheOrDataSource: function () {

                if (this.preLoadComposeMessageInitData) {
                    //in an array to match the jquery $.when
                    return $.Deferred().resolve(this.preLoadComposeMessageInitData);
                }

                return MessageHttpSvc.ComposeMessagePageInit();
            },

            templateSelected: function (selectedDataObject) {
                this.selectedTemplateData = selectedDataObject;
            },

            setCachedFutureAppointments: function (data) {
                this.cachedFutureAppointments = data;
            },

            setMessageObject: function (messageObject) {
                this.composeMesageToSend = messageObject;
            },

            sendMessage: function () {

                this.isSendingMessage = true;
                this.errorModel = {};

                //Send Regular Email only for RadiologyExamsCopy template

                if (this.selectedTemplateData.id == 'RadiologyExamsCopy') {

                    this.isSendingEmailMessage = true;

                    MessageHttpSvc.ComposeMessageSendEmailMessage(this.selectedTemplateData.id, this.composeMesageToSend)
                        .done(response => {
                            //this.mode = 'SuccessEmail';
                        }).fail((xhr, textStatus, obj) => {
                            if (IsModelStateError(xhr)) {
                                this.errorModel = xhr.responseJSON;
                            }

                        }).always(x => {
                            this.isSendingEmailMessage = false;
                        })
                }

                MessageHttpSvc.ComposeMessageSendMessage(this.selectedTemplateData.id, this.composeMesageToSend)
                    .done(response => {
                        //reset the data
                        this.recentlyUsedTemplates = response.recentlyUsedTemplateList;
                        this.physicianDropDownData = response.recentDoctorMailboxList;
                        this.reassignPhysiciansDropDownData = response.reassignDoctorMailboxList;

                        //reset the model
                        this.composeMesageToSend = {};

                        //invalidate a few of our caches. Going to just refresh them after any message template was sent. If this gets slow we can always invalidate based on the template id.
                        this.cachedPreferredPharmacies = null;

                        this.mode = 'Success';
                        this.$emit('messageHasBeenSent', this.composeModel);

                    }).fail((xhr, textStatus, obj) => {
                        if (IsModelStateError(xhr)) {
                            this.errorModel = xhr.responseJSON;
                        }

                    }).always(x => {
                        this.isSendingMessage = false;
                    })
            },

            showHideHeaderFooter: function (showHeader, showFooterWithBaseButtons) {
                this.showHeader = showHeader;
                this.showFooterWithBaseButtons = showFooterWithBaseButtons;
            },

            hideSend: function () {
                this.hideSendButton = true;
            },

            doneButtonClicked: function () {
                EventBus.$emit('SubScreenDoneButtonPushed');
            }
        },
        destroyed: function () {
            EventBus.$off('ClearError');
            EventBus.$off('IsUploading');
            EventBus.$off('goToTemplate');
        }
    };
</script>

